import { useState } from 'react';
import type { Product } from '../../types';

interface ProductImageProps {
  product: Product;
  className?: string;
  imageClassName?: string;
  aspectClassName?: string;
  naturalAspect?: boolean;
}

export default function ProductImage({ product, className = '', imageClassName = 'product-image-size', aspectClassName = 'aspect-square', naturalAspect = false }: ProductImageProps) {
  const imageSource = product.image.startsWith('/') || /^https?:\/\//.test(product.image) ? product.image : `/${product.image}`;
  const [ratio, setRatio] = useState<number | null>(null);
  const applyRatio = (img: HTMLImageElement) => {
    if (naturalAspect && img.naturalWidth && img.naturalHeight) setRatio(img.naturalWidth / img.naturalHeight);
  };

  return (
    <div
      className={`product-image-frame flex ${aspectClassName} items-center justify-center overflow-hidden rounded-xl bg-transparent ${className}`}
      style={ratio ? { aspectRatio: `${ratio} / 1` } : undefined}
    >
      <img
        src={imageSource}
        alt={product.name}
        loading="lazy"
        decoding="async"
        className={imageClassName}
        onError={(event) => { event.currentTarget.src = '/logos/tecnicelu.png'; }}
        onLoad={(event) => applyRatio(event.currentTarget)}
        ref={(el) => { if (el) applyRatio(el); }}
      />
    </div>
  );
}
